// src/pages/ComoFunciona.tsx
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

export default function ComoFunciona() {
  const steps = [
    {
      n: 1,
      title: "Guia de Captura",
      desc: "Tire fotos do veículo seguindo 8 ângulos sugeridos. O guia ajuda a cobrir todas as áreas importantes.",
    },
    {
      n: 2,
      title: "Validação de Ângulo",
      desc: "Indicadores confirmam se o enquadramento está correto antes de cada foto.",
    },
    {
      n: 3,
      title: "Reconstrução 3D",
      desc: "Unificamos as imagens e normalizamos luz/sombra para realçar imperfeições.",
    },
    {
      n: 4,
      title: "Detecção de Danos (IA)",
      desc: "A IA marca amassados, riscos e desalinhamentos com um mapa de calor por painel.",
    },
    {
      n: 5,
      title: "Precificação Inteligente",
      desc: "Com base na FIPE e no score de condição, estimamos a faixa entre 100% (excelente) e 70% (reparo necessário).",
    },
    {
      n: 6,
      title: "Relatório & Histórico",
      desc: "Gere um resumo com fotos, áreas críticas e faixa de preço. Salve no histórico ou compartilhe.",
    },
  ];

  return (
    <div className="container mx-auto px-6 py-20 max-w-6xl">
      {/* Título */}
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold">Como Funciona</h1>
        <p className="text-muted-foreground mt-3">
          Três passos simples para uma análise completa — da captura à precificação baseada na FIPE.
        </p>
      </div>

      {/* Etapas */}
      <div className="space-y-4 mb-12">
        {steps.map((s) => (
          <Card key={s.n} className="p-5 flex items-start gap-4">
            <div className="w-10 h-10 shrink-0 rounded-full bg-accent text-accent-foreground flex items-center justify-center font-bold">
              {s.n}
            </div>
            <div>
              <h3 className="text-lg font-semibold">{s.title}</h3>
              <p className="text-sm text-muted-foreground mt-1">{s.desc}</p>
            </div>
          </Card>
        ))}
      </div>

      {/* Faixa 100% → 70% + CTA */}
      <Card className="p-8">
        <h2 className="text-xl font-semibold mb-2">Entenda a faixa 100% → 70%</h2>
        <p className="text-sm text-muted-foreground mb-6">
          Após o scan, o sistema calcula um <b>Score de Condição</b> e cruza com a FIPE para sugerir a faixa de valor.
        </p>

        <div className="mb-6">
          <div className="h-2 w-full rounded bg-muted/60 overflow-hidden">
            <div className="h-full bg-primary/70" style={{ width: "70%" }} />
          </div>
          <div className="flex justify-between text-xs text-muted-foreground mt-2">
            <span>70%</span>
            <span>Faixa sugerida</span>
            <span>100%</span>
          </div>
        </div>

        {/* ÚNICO botão (sem “Ver demonstração”) */}
        <Button asChild>
          <Link to="/demo">Fazer primeiro scan</Link>
        </Button>
      </Card>
    </div>
  );
}
